import { QueryClient } from '@tanstack/react-query';

/**
 * Initialize tanstack query client for caching and managing api call state.
 */
export default function initializeQueryClient() {
  return new QueryClient();
}